<template>
  <div class="register-page-right">
    <p class="mb10">Creating an account with us, you'll get.</p>
    <ul>
      <li>
        <h4 class="is-size-6 has-text-weight-bold"><img src="@/assets/img/shopping_cart_24px.svg" alt=""/>Fast Checkout</h4>
        <p>Your payment info is saved and ready. </p>
      </li>
      <li>
        <h4 class="is-size-6 has-text-weight-bold"><img src="@/assets/img/access_time_24px.svg" alt=""/>Easy Reorder</h4>
        <p>One click away to reorder your favorites. </p>
      </li>
      <li>
        <h4 class="is-size-6 has-text-weight-bold"><img src="@/assets/img/favorite_border_24px.svg" alt=""/>Personalized Experience</h4>
        <p>Get better recommendations online and in person. </p>
      </li>
    </ul>

    <div class="register-page-login-form-wrapper" v-show="screen == 1">
        <form class="register-page-login-form" ref="loginForm">
        
          <h2 class="is-size-6 has-text-weight-bold mb10">Sign In</h2>	
          <!-- social icons -->
          <div class="social-icons-wrap is-flex is-flex-column">
            <div id="buttonDiv"></div>
            <div class="field mb-5">
              <div class="control">
                <a href="#" class="social-login-signup-wrapper mb10" @click.prevent="loginWithGoogle">
                  <div class="social-login-section">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 18 18" aria-hidden="true"><title>Google</title><g fill="none" fill-rule="evenodd"><path fill="#4285F4" d="M17.64 9.2045c0-.6381-.0573-1.2518-.1636-1.8409H9v3.4814h4.8436c-.2086 1.125-.8427 2.0782-1.7959 2.7164v2.2581h2.9087c1.7018-1.5668 2.6836-3.874 2.6836-6.615z"></path><path fill="#34A853" d="M9 18c2.43 0 4.4673-.806 5.9564-2.1805l-2.9087-2.2581c-.8059.54-1.8368.859-3.0477.859-2.344 0-4.3282-1.5831-5.036-3.7104H.9574v2.3318C2.4382 15.9832 5.4818 18 9 18z"></path><path fill="#FBBC05" d="M3.964 10.71c-.18-.54-.2822-1.1168-.2822-1.71s.1023-1.17.2823-1.71V4.9582H.9573A8.9965 8.9965 0 0 0 0 9c0 1.4523.3477 2.8268.9573 4.0418L3.964 10.71z"></path><path fill="#EA4335" d="M9 3.5795c1.3214 0 2.5077.4541 3.4405 1.346l2.5813-2.5814C13.4632.8918 11.426 0 9 0 5.4818 0 2.4382 2.0168.9573 4.9582L3.964 7.29C4.6718 5.1627 6.6559 3.5795 9 3.5795z"></path></g></svg>
                    <span class="letter-space-0_5 is-size-14">SIGN-IN WITH GOOGLE</span>
                  </div>
                </a>
              </div>
            </div>
            <div class="field mb0">
              <div class="control">
                <a href="#" class="social-login-signup-wrapper" @click.prevent="loginWithFacebook">
                  <div class="social-login-section">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><path  fill="#4285F4" d="M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v3.385z"/></svg>
                    <span class="letter-space-0_5 is-size-14">SIGN-IN WITH FACEBOOK</span>
                  </div>
                </a>
              </div>
            </div>  
          </div>
          <!-- social icons ends -->

          <div class="mt-20 mb-20 is-size-14 has-text-centered"><span class="has-text-dark">Or continue with:</span></div>

          <div class="field">
            <div class="control">
              <form ref="val_observer_loginform" @submit.prevent="getLoginToken()">
                <validation-provider :name="phone_email_rule_text" ref="login_email" :rules="phone_email_rules">
                  <template #default="{ errors }">
                    <input
                      class="input"
                      name="Email"
                      v-validate="'required|email'"
                      v-model="loginForm.email"
                      type="text"
                      placeholder="Phone Number or Email"
                    />
                    <span class="validation-error">{{ errors[0] }}</span>
                  </template>
                </validation-provider>
              </form>
            </div>
          </div>
    
        <button class="button is-large bg-secondary text-white hover-opacity-7 is-full-width mt-15" @click.prevent="getLoginToken()">SIGN IN</button>
      </form>
    
    </div>


    <!-- register page forgot pass -->
    <section class="register-page-forgot-pass-wrapper mt40" v-show="screen == 2">
      <p class="is-size-14 mb20 has-text-weight-semibold">{{ verification_code_sent_message }}</p>
   
        <div class="field">
          <div class="control">
            <form ref="val_observer_confirmation_form" @submit.prevent="submitCode()">
              <validation-provider name="confirmation code" ref="confirmation_code" rules="required">
                <template #default="{ errors }">
                  <input
                    class="input"
                    name="confirmation_code"
                    v-validate="'required'"
                    v-model="confirmation_code"
                    type="text"
                    placeholder="Confirmation Code"
                  />
                  <span class="validation-error">{{ errors[0] }}</span>
                </template>
              </validation-provider>
            </form>
        
            <button
              @click="resendConfirmationCode()"
              :disabled="codeResendTimer > 0"
              class="button mt20 is-large is-transparent is-full-width mb-20"
            >RESEND CODE <span v-if="codeResendTimer > 0" class="has-text-dark"> &nbsp; ({{ codeResendTimer }}S)</span></button>
            <button
              @click="submitCode()"
              class="button is-large bg-secondary text-white hover-opacity-7  is-full-width"
            >SIGN IN</button>
          </div>
    
      </div>
      
    </section>

  </div>
              
</template>
<script>
import Env from '@/env';
import { mapGetters, mapActions } from 'vuex';
import Helpers from '@/Components/Helpers/Helpers';
// import ForgotPasswordApis from '@/Components/Controllers/ForgotPasswordApis';
import LoginApis from '@/Components/Controllers/LoginApis';
import OrderHistoryApis from '@/Components/Controllers/OrderHistoryApis';
import CartApis from '@/Components/Controllers/CartApis';
import UserApis from '@/Components/Controllers/UserApis';
import VboutApis from '@/Components/Controllers/VboutApis';
import LoyalityApis from '@/Components/Controllers/LoyalityApis';
import moment from 'moment';

export default {

  name: 'RegisterPageLogin',
  data() {
    return {
      // Login
      screen: 1,
      verification_code_sent_message: 'We sent you a confirmation code!',
      phone_email_rule_text: 'email',
      loginForm: {
        email: '',
        platform: "web",
        app_version: "0.1"
      },
      auth_code_token: '',
      confirmation_code: '',
      codeResendTimer: 0,
    };
  },
  watch: {
    'loginForm.email'(val) {
      this.loginForm.email = val.replaceAll(/\s/g,'').trim();
    },
  },
  computed: {
    ...mapGetters({
      vg_selectedStore: "location/selected", 
      vg_userId: "getLoggedInUserId",
      vg_businessProfile: "businessprofile/detail", 
      vg_businessLoyality: "businessprofile/businessLoyality",
      vg_cartItems: "cart/cartItems",
    }),
   
    phone_email_rules() {
      let rule = 'required';
      if(this.loginForm.email){
        // if first letter user type is not a number then he must be typing email
        if( isNaN(this.loginForm.email.charAt(0)) || (this.loginForm.email.indexOf('@') > 1) ){
            rule ='|email';
            this.phone_email_rule_text = 'email';
        } else {
          rule ='|phone_number|numeric';
          this.phone_email_rule_text = 'phone';
        }
      } 
      return rule;
    },
  
  },

  methods: {
    /**
     * Login with google
     */
    async loginWithFacebook() {
      const self = this;
      //self.va_spinner(true);
      window.FB.login(async function(response) {
        if (response.authResponse) {
          //let fbUserData = await Helpers.getfacebookUserInfo();
          let res = await self.loginWithSocial({
            social_type: 'facebook',
            access_token: response.authResponse.accessToken
          });
          if(res.status == 200) {
            await self.setLoginSuccessUserData(res);
            self.va_spinner(false);
          } 
          self.va_snackbar({
            type: res.status == 200 ? 'success' : 'warning',
            message: res.status == 200 ? res.data.msg : res.response.data.msg,
          });  
          
        } else {
          self.va_spinner(false);
          self.va_snackbar({
            type: 'warning',
            message: 'User cancelled login or did not fully authorize.',
          });
        }
      }, { 
        scope: 'email'
      });
      return false;
    },


    /**
     * Login with google
     */
    async loginWithGoogle () {
      const self = this;
      this.va_spinner(true);
      this.$gAuth
        .signIn()
        .then( async (GoogleUser) => {
          let googleResponse = GoogleUser.getAuthResponse();
          let res = await self.loginWithSocial({
            social_type: 'google',
            access_token: googleResponse.access_token
          });
          if(res.status == 200){
            await this.setLoginSuccessUserData(res);
          }
          this.va_snackbar({
            type: res.status == 200 ? 'success' : 'warning',
            message: res.status == 200 ? res.data.msg : res.response.data.msg,
          });
          this.va_spinner(false);
        })
        .catch(error => {
          this.va_spinner(false);
          console.log('error', error)
        })
    },

    /**
     * Login
     */
    async getLoginToken() {
      let validation = await Helpers.validateRefs(this, [
        "login_email",
      ]);
      if (!validation) {
       return;
      }
      // now check what value user passed
      let obj = {};
      if(this.phone_email_rule_text == 'phone'){
        obj.phone = this.loginForm.email;
      } else {
        obj.email = this.loginForm.email;
      }
      // Extra need to pass
      obj.business_id = this.vg_businessProfile.id;
      obj.business_name = this.vg_businessProfile.name;
      obj.business_slug = this.$route.params.business_slug;
      obj.logo_url = (this.vg_businessProfile && this.vg_businessProfile.branding && this.vg_businessProfile.branding.logo_url) ? this.vg_businessProfile.branding.logo_url : '';
      // obj.location_id = this.vg_selectedStore.id ? this.vg_selectedStore.id : '';
      // obj.location_slug = this.vg_selectedStore.slug ? this.vg_selectedStore.slug : '';

      this.va_spinner(true);
      let res = await LoginApis.loginViaEmailOrPhone(obj);
      this.va_spinner(false);
      if(res.status == 200){
        this.$refs.val_observer_loginform.reset();
        this.$refs.val_observer_confirmation_form.reset();
        this.screen = 2;
        if(res.data.msg){
          this.verification_code_sent_message = res.data.msg;
        }
        this.auth_code_token = res.data.payload.auth_code_token;
        this.initConfirmationTiming();
      } else {
        this.va_snackbar({
          type: 'warning',
          message: res.response ? res.response.data.msg : 'Please try again later.',
        });
      }
    },

      /**
     * Login with social
     */
    async loginWithSocial(data){
      return await LoginApis.loginWithSocial(data);
    },

    /**
     * Resend Confirmation code
     */
    async resendConfirmationCode() {
      // now check what value user passed
      let obj = {};
      if(this.phone_email_rule_text == 'phone'){
        obj.phone = this.loginForm.email;
      } else {
        obj.email = this.loginForm.email;
      }
      // Extra need to pass
      obj.business_id = this.vg_businessProfile.id;
      obj.business_name = this.vg_businessProfile.name;
      obj.business_slug = this.$route.params.business_slug;
      obj.logo_url = (this.vg_businessProfile && this.vg_businessProfile.branding && this.vg_businessProfile.branding.logo_url) ? this.vg_businessProfile.branding.logo_url : '';
      // obj.location_id = this.vg_selectedStore.id ? this.vg_selectedStore.id : '';
      // obj.location_slug = this.vg_selectedStore.slug ? this.vg_selectedStore.slug : '';

      this.va_spinner(true);
      let res = await LoginApis.loginViaEmailOrPhone(obj);
      this.va_spinner(false);
      if(res.status == 200){
        this.$refs.val_observer_loginform.reset();
        this.$refs.val_observer_confirmation_form.reset();
        this.auth_code_token = res.data.payload.auth_code_token;
        this.initConfirmationTiming();
      } else {
        this.va_snackbar({
          type: 'warning',
          message: res.response.data.msg,
        });
      }
    },

     /**
     * Submit code to get login
     */
    async submitCode() {
      let validation = await Helpers.validateRefs(this, [
        "confirmation_code",
      ]);
      if (!validation) {
       return;
      }
      this.va_spinner(true);
      let res = await LoginApis.verifyPhoneOrEmailLoginToken({
        auth_code_token: this.auth_code_token,
        auth_code: this.confirmation_code,
      });
      if(res.status == 200) {
        await this.setLoginSuccessUserData(res);
        // If has location data redirect to location
        if(this.vg_selectedStore && this.vg_selectedStore.slug){
          this.$router.push({
            name: 'StoreLanding',
            params: {
              business_slug: this.$route.params.business_slug,
              store_slug: this.vg_selectedStore.slug
            }
          })
        } else {
          // Else throw user to homepage
          this.$router.push({
            name: 'HomePage',
            params: {
              business_slug: this.$route.params.business_slug
            }
          })
        }
        
      }
      this.va_spinner(false);
      this.va_snackbar({
        type: res.status == 200 ? 'success' : 'warning',
        message: res.status == 200 ? res.data.msg : res.response.data.msg,
      });
      
    },

    /**
     * on success login set datas
     */
    async setLoginSuccessUserData(res) {
      const self = this;
      // Push user to vbout
      await VboutApis.upsertUser(res.data.payload, this.vg_selectedStore.id);

      // If user has email_verification_status = true tag it 
      if(res.data.payload.email_verification_status){
        await VboutApis.addUserTag({
          email: res.data.payload.email,
          tagname: 'verified',
        }, this.vg_selectedStore.id);
      }
      // casl_opt_in as marketing notification
      if(res.data.payload.marketing_notification){
        await VboutApis.addUserTag({
          email: res.data.payload.email,
          tagname: 'casl_opt_in',
        }, this.vg_selectedStore.id);
      }

      // Add user location on login
      if(this.vg_selectedStore.id){
        UserApis.addUserLocation(res.data.payload.id, this.vg_selectedStore.id, this.$route.query);
      }
      
      // Reset login form 
      this.loginForm.email = '';
      this.$store.dispatch("SET_USER_TOKEN", res.data.payload.token);
      this.$store.dispatch("SET_USER_DETAILS", res.data.payload);
      this.$store.dispatch("SET_USER_LOGGEDIN_DATE", moment().format('YYYY-MM-DD HH:mm:ss'));
      this.va_spinner(false);

      // Start loyalty stuffs only if business is active
      if(this.vg_businessLoyality.id && this.vg_businessLoyality.is_active) {
        // On login if usr has no subscribe to loyalty subscribe and if yes show baloons
        let loyaltyJoinRes = await this.va_joinUserOnLoyalityProgram({
          user_id: res.data.payload.id,
          business_id: this.vg_businessProfile.id
        })

        // Signup but as signin
        if( (loyaltyJoinRes.status == 201) && (loyaltyJoinRes.data.payload.welcome_bonus > 0) ) {
          // show loyalty bonus point for signup
            bus.$emit('loyality-signup-congratulations', {
            modal: true,
            point: loyaltyJoinRes.data.payload.welcome_bonus,
            message: "Sign in Bonus!",
          })
        }

        // Show loyalty referral point
        if( (loyaltyJoinRes.status == 201) && (loyaltyJoinRes.data.payload.referral_bonus > 0) ) {
          bus.$emit('loyality-referral-congratulations', {
            modal: true,
            point: loyaltyJoinRes.data.payload.referral_bonus,
            message: "A little something for being referred!",
          })
        }
      }

    },

    /**
     * Init token time
     */
    initConfirmationTiming() {
      this.codeResendTimer = 60;
      let timer = setInterval(() => {
        this.codeResendTimer = (this.codeResendTimer - 1)
        if(this.codeResendTimer == 0){
          clearInterval(timer);
        }
      }, 1000)
    },


    ...mapActions({
      va_setGuestLandedQueries: "location/setGuestLandedQueries",
      va_setPendingItem: "cart/setPendingItem",
      va_setAllOrders: "orderhistory/setAllOrders",
      va_spinner: "spinner/setSpinner",
      va_snackbar: "snackbar/setSnackbar",
      va_joinUserOnLoyalityProgram: "userloyalitysubscription/joinUserOnLoyalityProgram",
    }),
  },
};
</script>
